var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 184,
    viewBox: "0 0 213 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.7 66.6999C98.2996 66.2999 83.3996 72.3999 72.6996 83.4999C61.7996 94.2999 55.8996 109.2 56.1996 124.5C55.7996 140.6 62.4996 156.1 74.5996 166.8C84.5996 176.5 97.8996 182 111.9 182.2C123.2 182.4 134.2 178.3 142.8 170.9C151.4 164 156.9 154 158 143.1H119.7V121.4H176.2L158.9 91.6999L157.3 88.7999C147.1 74.9999 130.9 66.7999 113.7 66.6999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.4 47.4L106 0L74.5996 54.7C86.3996 48.2 99.7996 44.9 113.2 45.1C120 45.1 126.7 45.9 133.3 47.6",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.6 180.2L162.5 183.5H212.2L183.1 133.2C182.8 141.4 181.4 149.5 179.1 157.3C176.2 165.8 171.5 173.7 165.4 180.3",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 126.4L0 183.6H58.5L55.9 181.1C41.4 166.6 33.1 146.9 33 126.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav1);
export default __webpack_public_path__ + "static/media/fav (1).fa856c33c811a95041c7935c0ec8d772.svg";
export { ForwardRef as ReactComponent };